// extracted by mini-css-extract-plugin
export default {"root":"tCFrUaErSmH8yTgBAFzE","wrap":"nlAqQL00DsUodg5lm8KO","icon":"zvOCA_eiK3jkjEvDTY1u","text":"NeuMRKPw58OGQVQSh1iz"};